import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { User } from '../../../../store/User';

export interface UpstackAutocompleteParams {
  options: string[];
  onChange: (event: React.SyntheticEvent<Element, Event>, value: string | null | User) => void;
  value: string;
}

export const UpstackAutocomplete = ({ options, onChange, value }: UpstackAutocompleteParams) => {
  const [localValue, setLocalValue] = React.useState<User | string | undefined>(value);
  return (
    <Autocomplete
      getOptionLabel={(option: User | string) => {
        return typeof option === 'string' ? option : `${(option as User).firstName} ${(option as User).lastName}` || '';
      }}
      disableClearable
      options={options}
      value={localValue}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
        />
      )}
      onChange={(e, v) => {
        setLocalValue(v);
        onChange(e, v);
      }}
    />
  );
};
